import React from 'react';
import IndustryTemplate, { IndustryConfig } from './IndustryTemplate';

const config: IndustryConfig = {
  slug: 'law-firms',
  label: 'Law',
  heroTitle: 'Monetize Your',
  heroDim: 'Legal Data',
  heroSubtitle:
    'Law firms generate vast amounts of structured data — case outcomes, contracts, filings, and more. Efficient helps you license this data to AI companies, creating a new revenue stream with no disruption to your practice.',
  heroImage: '/law-firm-hero.jpg',
  heroImageAlt: 'Law firm attorneys',
  processSteps: [
    {
      num: '01',
      icon: '/step_door.svg',
      title: 'Data Assessment',
      desc: "We evaluate your firm's data holdings — case files, contracts, filings — and identify what has value in the AI training market.",
    },
    {
      num: '02',
      icon: '/step_onboard.svg',
      title: 'Qualification',
      desc: "We identify buyers who need legal training data, match your data to their requirements, and provide a transparent quote.",
    },
    {
      num: '03',
      icon: '/step_extract.svg',
      title: 'Preparation',
      desc: 'We anonymize, structure, and prepare your data for delivery — ensuring full compliance with attorney-client privilege and data privacy laws.',
    },
    {
      num: '04',
      icon: '/step_paid.svg',
      title: 'Revenue Recognition',
      desc: 'We deliver the dataset to the buyer and pay out your revenue share — a new income stream with zero operational overhead.',
    },
  ],
  valueHeading: 'What legal data can be monetized',
  valueProps: [
    {
      title: 'Case Outcomes & Summaries',
      desc: "Historical case records and outcomes represent hard-won experience — the kind of judgment that only comes from years of real practice.",
    },
    {
      title: 'Contracts & Clause Libraries',
      desc: 'Your contract templates and negotiated clauses encode refined legal knowledge and deal-making expertise built across hundreds of transactions.',
    },
    {
      title: 'Court Filings & Motions',
      desc: 'Pleadings, briefs, and procedural documents capture the craft of legal argumentation developed over countless matters.',
    },
  ],
  aiAccelHeading: 'Move faster with AI — across your entire practice.',
  aiAccelPoints: [
    {
      title: 'Contract Review & Drafting',
      desc: 'AI tools can review standard contracts in minutes, flag anomalies, and draft first-pass agreements — freeing your attorneys for higher-value work.',
    },
    {
      title: 'Legal Research Acceleration',
      desc: 'Surface relevant case law, statutes, and precedents faster than traditional research methods, cutting hours from every matter.',
    },
    {
      title: 'Billing & Matter Management',
      desc: 'Automate time-entry narratives, flag billing anomalies, and get AI-assisted insights into matter profitability across your book of business.',
    },
  ],
  ctaHeading: 'Ready to put your data to work?',
  ctaBody:
    'Join our network of law firm partners and start generating revenue from data you already hold — securely and compliantly.',
};

export default function LawFirms() {
  return <IndustryTemplate config={config} />;
}
